import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';

export const AddOnSelector = ({ addOns, selectedAddOns, onChange }) => {
  if (!addOns || addOns.length === 0) return null;

  return (
    <Card
      data-testid="addon-selector-card"
      className="border border-[#B8860B]/30 shadow-xl bg-[#0B132B]"
    >
      <CardHeader>
        <CardTitle className="text-2xl text-[#F4F1EA]">Enhance Your Stay</CardTitle>
        <p className="text-sm text-[#F4F1EA]/70 mt-1">
          Optional extras to make your visit even better
        </p>
        <div
          data-testid="addon-upsell-banner"
          className="mt-3 inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-[#B8860B]/15 border border-[#B8860B]/40"
        >
          <span className="text-[#B8860B] text-sm font-semibold">★ Most guests add:</span>
          <span className="text-[#F4F1EA]/85 text-sm">Firewood + 2 Chairs — $20</span>
        </div>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          {addOns.map((addon) => (
            <div
              key={addon.id}
              className="flex items-center justify-between p-4 bg-[#050814] border border-[#B8860B]/20 rounded-lg hover:border-[#B8860B]/50 transition-colors"
            >
              <div className="flex-1 pr-4">
                <p className="font-semibold text-[#F4F1EA]">{addon.name}</p>
                <p className="text-sm text-[#F4F1EA]/70 mt-0.5">{addon.description}</p>
                <p className="text-[#B8860B] font-bold mt-1">${addon.price.toFixed(2)}</p>
              </div>
              <select
                data-testid={`booking-addon-qty-${addon.id}`}
                value={selectedAddOns[addon.id] || 0}
                onChange={(e) => onChange(addon.id, e.target.value)}
                className="p-2 bg-[#0B132B] border border-[#B8860B]/30 text-[#F4F1EA] rounded focus:outline-none focus:ring-2 focus:ring-[#B8860B]"
              >
                <option value="0">None</option>
                <option value="1">1</option>
                {addon.category !== 'Ranch Credits' && (
                  <>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                  </>
                )}
              </select>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};
